import { render, staticRenderFns } from "./BasicStep.vue?vue&type=template&id=21e524bb&"
import script from "./BasicStep.vue?vue&type=script&lang=ts&"
export * from "./BasicStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports